import { Alert, Button, Checkbox, Col, Form, Input, Row, Select, Tooltip } from "antd";

import './AddContractComponent.scss';
import { useTranslation } from "react-i18next";
import CreateContract from "../../../models/CreateContract";
import { useEffect, useState } from "react";
import HotelInfo from "../../../models/HotelInfo";
import { set } from "lodash";

interface AddContractComponentProps {
    onFinish: (contractData: CreateContract) => void;
    onCancel: () => void;
    resetFields: number;
    loading: boolean;
    hotels: HotelInfo[];
    countries: { key: string; value: string }[];
}

const AddContractComponent = (props: AddContractComponentProps): JSX.Element => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const { onFinish, onCancel, resetFields } = props;

    const [loading, setLoading] = useState<boolean>(props.loading);


    useEffect(() => {
        setLoading(props.loading);
    }, [props.loading]);


    useEffect(() => {
        form.resetFields();
        setIsAllSelected(false);
        setSelectedHotels([]);
    }, [resetFields]);

    const onCancelAdd = (): void => {
        form.resetFields();
        onCancel();
    }


    const [selectedHotels, setSelectedHotels] = useState<string[]>([]);
    const allHotelIds = props.hotels.map(h => h.id);
    const [isAllSelected, setIsAllSelected] = useState<boolean>(false);

    const handleSelectChange = (value: any) => {
        let newSelectedHotels;
        if (value.includes("all") || value.length === allHotelIds.length) {
            newSelectedHotels = allHotelIds; // Selecciona todos
            setIsAllSelected(true);
        } else {
            newSelectedHotels = value;
            setIsAllSelected(false);
        }

        setSelectedHotels(newSelectedHotels);
    };



    useEffect(() => {
        form.setFieldValue('hotelsAffected', selectedHotels);
    }, [selectedHotels]);


    const onAddContract = (): void => {
        let contract: CreateContract = {
            name: form.getFieldValue('name'),
            pmsCode: form.getFieldValue('pmsCode') ?? '',
            integrationCode: form.getFieldValue('integrationCode'),
            isBase: isBaseContract,
            isActive: isActive,
            hotelsAffected: selectedHotels,
            marketCode: form.getFieldValue('marketCode') ?? ''
        }

        onFinish(contract);
    }

    const [isActive, setIsActive] = useState<boolean>(true);
    const [isBaseContract, setIsBaseContract] = useState<boolean>(false);
    const [integrationCode, setIntegrationCode] = useState<string>("");

    const isoToFlagEmoji = (isoCode: string): string => {
        return isoCode
            .toUpperCase()
            .split('')
            .map(char => String.fromCodePoint(0x1F1E6 + char.charCodeAt(0) - 65))
            .join('');
    };

    useEffect(() => {
        if (isBaseContract) {
            const allIds = props.hotels.map(x => x.id);
            form.setFieldsValue({ hotelsAffected: allIds });
            setSelectedHotels(allIds); // <-- aquí sincronizas el estado
            setIsAllSelected(true);
        } else {
            setSelectedHotels([]);
            setIsAllSelected(false);
        }
    }, [isBaseContract, props.hotels]);




    return (
        <div className="add-contract">
            <Form form={form}
                layout="vertical"
                onValuesChange={(changedValues, allValues) => {
                    setIntegrationCode(allValues.integrationCode || "");
                }}
                onFinish={onAddContract} >
                <Row gutter={16}>
                    <Col xs={24}>
                        <Form.Item
                            name="name"
                            label={t("components.contract-form-add.name")}
                            rules={[{ required: true, message: t("components.contract-form-add.name-required") || "" }]}
                        >
                            <Input className="app-input" allowClear />
                        </Form.Item>
                    </Col>
                    <Col xs={24}>
                        <Form.Item
                            name="pmsCode"
                            label={t("components.contract-form-add.pms-code")}
                        >
                            <Input className="app-input" allowClear />
                        </Form.Item>
                    </Col>
                    <Col xs={24}>
                        <Form.Item
                            name="integrationCode"
                            label={t("components.contract-form-add.integration-code")}
                            rules={[{ required: !isBaseContract, message: t("components.contract-form-add.code-integration-required") || "" }]}
                        >

                            <Input className="app-input" allowClear />
                        </Form.Item>
                    </Col>
                    <Col xs={24}>
                        <Form.Item name="isBaseContract" label={t("components.contract-form-add.is-base-contract")} initialValue={false}>
                            <Select onChange={setIsBaseContract} className="app-input" defaultValue={false} allowClear>
                                <Select.Option value={true}>{t("components.contract-form-add.is-base-contract-yes")}</Select.Option>
                                <Select.Option value={false}>{t("components.contract-form-add.is-base-contract-no")}</Select.Option>
                            </Select>
                        </Form.Item>
                        {
                            //If isBaseContract == true then show the next message:

                            isBaseContract && <Alert className="alert-base-message" message={t("components.contract-form-add.is-base-contract-message")} type="warning" />
                        }
                        {isBaseContract && integrationCode === "" && (
                                <Form.Item
                                    name="emptyIntegrationCode"
                                    valuePropName="checked"
                                    rules={[
                                        {
                                            required: true,
                                            message: t("components.contract-form-add.check-box-required") || "",
                                        },
                                    ]}
                                >
                                    <Checkbox>
                                        {t("components.contract-form-add.confirm-empty-integration-code")}
                                    </Checkbox>
                                </Form.Item>
                            )}
                    </Col>
                     <Col xs={24}>
                        <Form.Item name="marketCode" label={t("components.contract-form-add.market-code")} >
                            <Select
                                className="app-input"
                                allowClear
                                placeholder={t("components.contract-form-add.market-code")}
                                showSearch
                                filterOption={(input, option) => {
                                    const search = input.toLowerCase();
                                    const key = String(option?.value || '').toLowerCase();
                                    const value = String(option?.label || '').toLowerCase();

                                    return key.includes(search) || value.includes(search);
                                }}
                            >
                                {props.countries.map((country) => (
                                    <Select.Option key={country.key} value={country.key} label={country.value}>
                                        <Tooltip title={country.value} placement="right">
                                            <span>{isoToFlagEmoji(country.key)} {country.value}</span>
                                        </Tooltip>
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    
                    <Col xs={24}>
                        <Form.Item name="isActive" label={t("components.contract-form-add.is-active")} initialValue={true}>
                            <Select onChange={setIsActive} className="app-input" allowClear>
                                <Select.Option value={true}>{t("components.contract-form-add.is-active-yes")}</Select.Option>
                                <Select.Option value={false}>{t("components.contract-form-add.is-active-no")}</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24}>
                        <Form.Item
                            name="hotelsAffected"
                            initialValue={[]}
                            label={t("components.contract-form-add.hotels-affected")}
                            rules={[{ required: true, message: t("components.contract-form-add.hotels-required") || "" }]}
                        >
                            <Select
                                disabled={isBaseContract}
                                allowClear
                                mode="multiple"
                                className="app-select"
                                value={selectedHotels}
                                onChange={handleSelectChange}
                                dropdownRender={menu => (
                                    <>
                                        <div style={{ padding: "8px", borderBottom: "1px solid #eee" }}>
                                            <Checkbox
                                                checked={isAllSelected}
                                                onChange={() => handleSelectChange(["all"])}
                                            >
                                                {t('components.contract-form-add.select-all-hotels')}
                                            </Checkbox>
                                        </div>
                                        {menu}
                                    </>
                                )}
                                options={props.hotels.map(hotel => ({
                                    label: hotel.name,
                                    value: hotel.id,
                                }))}
                            />
                        </Form.Item>
                    </Col>
                    <div className="actions">
                        <Button disabled={loading} className="app-button danger" type="primary" onClick={onCancelAdd}>
                            {t("components.contract-form-add.cancel")}
                        </Button>
                        <Button disabled={loading} loading={loading} className="app-button" type="primary" htmlType="submit">
                            {t("components.contract-form-add.save")}
                        </Button>
                    </div>
                </Row>
            </Form>
        </div>
    )
}

export default AddContractComponent;